import React from 'react';

function WebSvg(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 337.098 337.098" style={{
            transform: "translateZ(50px)"
        }}>
            <defs>
                <linearGradient
                    id="web-svg-linear-gradient"
                    x1="209.099"
                    x2="115.762"
                    y1="35.613"
                    y2="250.168"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stopColor="#5a1bb3"/>  {/*208 blue 265*/}
                    <stop offset="1" stopColor="#5b1a91"/>  {/*216 blue 273*/}
                </linearGradient>
            </defs>
            <g data-name="Layer 3">
                <path
                    d="M37.349 280.012l69.498 40.39a5.46 5.46 0 005.474.007l174.496-100.747a5.46 5.46 0 00.038-9.435L215.5 168.28a5.46 5.46 0 00-5.55.01L37.309 270.595a5.46 5.46 0 00.04 9.417z"
                    opacity="0.1"
                />
                <g style={{ isolation: "isolate" }}>
                    <path
                        fill="#ba95de"
                        d="M103.539 267.813L103.561 276.699 146.843 301.842 146.8 292.953 103.539 267.813z"
                    />
                    <path
                        fill="#CBA9EB"
                        d="M146.8 292.953L146.843 301.842 249.382 242.654 249.342 233.764 146.8 292.953z"
                    />
                    <path
                        fill="#EEDEFF"
                        d="M103.539 267.813L146.8 292.953 249.342 233.764 206.078 208.618 103.539 267.813z"
                    />
                    <path
                        fill="#EEDEFF"
                        d="M103.539 267.813L249.342 233.764 249.342 233.764 206.078 208.618 103.539 267.813z"
                        opacity="0.5"
                    />
                </g>
                <g style={{ isolation: "isolate" }}>
                    <path
                        fill="#ba95de"
                        d="M143.51 276.399L135.812 271.936 135.588 191.935 143.266 196.397 143.51 276.399z"
                    />
                    <path
                        fill="#c0c5d1"
                        d="M143.266 196.397L135.588 191.935 205.244 151.712 212.927 156.182 143.266 196.397z"
                    />
                    <path
                        fill="#CBA9EB"
                        d="M212.927 156.182L213.169 236.191 143.51 276.399 143.266 196.397 212.927 156.182z"
                    />
                </g>
                <path
                    fill="#ba95de"
                    d="M73.363 285.532L65.93 283.454 34.116 126.553 41.539 128.631 73.363 285.532z"
                />
                <path
                    fill="#CBA9EB"
                    d="M41.539 128.631L34.116 126.553 241.059 7.088 248.474 9.149 41.539 128.631z"
                />
                <path
                    fill="#EEDEFF"
                    d="M248.474 9.149L280.304 166.058 73.363 285.532 41.539 128.631 248.474 9.149z"
                />
                <path
                    fill="url(#web-svg-linear-gradient)"
                    d="M242.933 21.661L271.204 162.994 79.591 273.849 50.222 130.686 242.933 21.661z"
                />
                <g style={{ isolation: "isolate" }}>
                    <path
                        fill="#f6f0ff"
                        d="M218.743 53.481L219.972 58.905 189.695 76.388 188.474 70.959 218.743 53.481z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M162.116 139.959L232.26 99.46l15.243 67.547-70.144 40.5zm74.146-.017l-6.863-30.394-59.545 34.383 6.857 30.392 59.551-34.381z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M226.926 75.831L228.082 80.938 157.938 121.434 156.788 116.33 226.926 75.831z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M136.354 137.041L137.308 141.283 95.418 165.467 94.465 161.223 136.354 137.041z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M134.191 127.451L135.151 131.71 93.264 155.897 92.299 151.635 134.191 127.451z"
                    />
                    <path
                        fill="#9F72E8"
                        d="M85.977 146.374l53.494-30.888 23.417 103.774-53.493 30.888zm68.419 70.64l-6.799-30.155-41.892 24.18 6.8 30.16 41.89-24.186zm-12.33-54.642l-.96-4.258-41.89 24.183.965 4.257 41.884-24.182zm-6.915-30.662l-.96-4.259L92.3 151.635l.965 4.262 41.887-24.187zm4.752 21.074l-.96-4.26-41.887 24.185.96 4.262 41.887-24.187zm-2.595-11.5l-.954-4.243-41.89 24.182.954 4.244 41.89-24.184z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M229.524 87.331L230.671 92.432 160.532 132.931 159.38 127.83 229.524 87.331z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M159.198 87.859L160.43 93.288 83.962 137.433 82.739 132.007 159.198 87.859z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M226.563 41.34l-150.9 87.123 29.423 130.413 150.906-87.12zm4.108 51.094L205 107.258l-44.468 25.673-1.152-5.1 70.144-40.5 1.147 5.103zm-3.744-16.603l1.155 5.107-70.144 40.496-1.15-5.104 70.139-40.499zm-1.002-4.469l-70.15 40.497-1.15-5.116 70.136-40.499 1.164 5.118zm-145.86 58.93l140.807-81.296 2.595 11.498-140.808 81.294-2.594-11.497zm29.33 119.856L85.977 146.374l53.494-30.888 23.417 103.774-53.493 30.888zm52.721-110.19l70.144-40.497 15.243 67.547-70.144 40.5-15.243-67.55z"
                        opacity="0.8"
                    />
                    <path
                        fill="#9F72E8"
                        d="M236.262 139.942L229.399 109.548 169.854 143.931 176.712 174.323 236.262 139.942z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M224.761 66.244L225.925 71.362 155.775 111.859 154.626 106.743 224.761 66.244z"
                    />
                    <path
                        fill="#f6f0ff"
                        d="M147.597 186.859L154.396 217.013 112.506 241.198 105.705 211.04 147.597 186.859z"
                    />
                    <path
                        fill="#9F72E8"
                        d="M80.065 130.291l140.807-81.295 2.595 11.498-140.808 81.294zm80.365-37.003l-1.232-5.429-76.46 44.148 1.224 5.426 76.468-44.145zm59.542-34.383l-1.229-5.424-30.269 17.478 1.22 5.429 30.278-17.483z"
                    />
                </g>
                <path
                    fill="#f6f0ff"
                    d="M138.943 148.524L139.903 152.783 98.015 176.971 97.056 172.709 138.943 148.524z"
                />
                <path
                    fill="#f6f0ff"
                    d="M141.106 158.114L142.065 162.372 100.181 186.554 99.222 182.297 141.106 158.114z"
                />
                <path
                    fill="#0FB4BA"
                    d="M100.726 101.709L109.009 142.512 85.977 155.549 75.432 152.35 68.371 150.043 62.952 123.52 100.726 101.709z"
                />
                <path
                    fill="#0B9CA1"
                    d="M68.371 150.043L81.774 144.153 85.977 155.549 68.371 150.043z"
                />
                <path
                    fill="#EEDEFF"
                    d="M95.742 113.009L96.239 115.452 72.714 129.342 72.154 126.625 95.742 113.009z"
                />
                <path
                    fill="#EEDEFF"
                    d="M97.527 120.465L98.024 122.908 74.493 136.798 73.939 134.082 97.527 120.465z"
                />
                <path
                    fill="#EEDEFF"
                    d="M99.829 127.497L100.323 129.939 76.798 143.827 76.239 141.114 99.829 127.497z"
                />
                <path
                    d="M290.3 262.051c15.21 8.78 15.28 23.014.177 31.79-15.106 8.778-39.682 8.786-54.887.005-15.206-8.78-15.288-23.019-.18-31.8 15.098-8.774 39.682-8.774 54.89.005z"
                    opacity="0.1"
                />
                <path
                    fill="#b64fff"
                    d="M266.307 120.333s-.616-7.02-10.576-6.51a174.8 174.8 0 00-19.903 2.344l-16.46-16.067s-4.295.916-5.07 3.823c0 0 11.374 19.468 19.532 22.589 0 0 35.895 9.21 32.477-6.18z"
                />
                <path
                    fill="#efb185"
                    d="M218.525 100.345s-.84-5.042-2.254-6.832a9.046 9.046 0 00-3.406-2.831c-.593-.21.67 2.139 1.104 2.884.423.746.224 2.851-3.857-.593-4.076-3.453-3.466-2.23-3.509-1.782-.045.45 2.737 9.052 7.894 12.193a7.332 7.332 0 014.028-3.039z"
                />
                <path
                    fill="#8525d9"
                    d="M233.83 126.512c-8.158-3.121-19.532-22.589-19.532-22.589a4.081 4.081 0 011.32-1.978c2.725 3.687 10.75 14.418 15.941 20.038 6.321 6.845 34.814 1.344 34.916 1.111-1.41 11.427-32.645 3.418-32.645 3.418z"
                />
                <path
                    fill="#111114"
                    d="M262.155 256.351s-3.931.946-2.76 3.167c1.167 2.204 6.061 5.289 6.788 6.695.732 1.391 4.93 6.247 6.093 5.665 1.167-.59 4.366-.144 3.478-6.03-.877-5.879-8.311-10.212-13.6-9.497z"
                />
                <path
                    fill="#111114"
                    d="M267.355 268.954s2.997 5.214-1.49 7.45c-4.5 2.245-3.665-1.014-13.489 3.637-9.823 4.657-12.058-.453-12.055-1.693-.003-1.24 6.472-4.745 8.615-5.77 2.151-1.034 6.202-2.954 6.202-2.954l12.265-2.413z"
                />
                <path
                    fill="#16162f"
                    d="M267.528 177.401s3.085 34.254 3.426 38.11c.335 3.858 7.32 33.883 5.91 47.389 0 0-6.818 8.146-14.082 1.241 0 0-5.461-37.877-8.132-46.29-2.66-8.427-4.337-34.747-4.337-34.747z"
                />
                <path
                    fill="#16162f"
                    d="M255.63 174.347s2.613 22.119 5.128 44.065c0 0 7.36 43.097 7.559 49.485 0 0-13.156 6.132-15.824-.101 0 0-7.074-37.814-8.973-45.63-1.902-7.822-8.651-32.17-8.027-45.479.616-13.3 20.136-2.34 20.136-2.34z"
                />
                <path
                    fill="#2a3554"
                    d="M268.317 267.897c-.198-6.388-7.559-49.485-7.559-49.485-1.692-14.775-3.73-32.075-4.675-40.203l-9.017 3.66a152.072 152.072 0 003.905 44.004c4.409 18.625 8.35 37.031 9.909 44.407a35.752 35.752 0 007.437-2.383zM276.864 262.9c1.41-13.506-5.575-43.531-5.91-47.388-.326-3.673-1.91-33.059-2.168-36.023l-8.263 4.622s-.227 24.703 3.383 38.444c3.304 12.505 4.076 37.342 5.76 44.323 4.163-.366 7.198-3.978 7.198-3.978z"
                />
                <path
                    fill="#b64fff"
                    d="M263.313 113.902s7.632 2.8 4.922 15.54c-2.708 12.737-4.698 21.005-3.949 25.545.761 4.555 3.833 21.357 5.141 24.377 0 0 1.144 5.197-18.178 10.058 0 0-17.47 4.048-15.759-8.808 1.726-12.88-2.234-26.265-3.252-31.024-1.03-4.763-5.008-14.066 6.306-21.923 11.303-7.858 17.017-13.373 24.769-13.765z"
                />
                <path
                    fill="#efb185"
                    d="M254.088 108.804s-.046 6.499 2.608 10.267c2.41 3.414-12.336 8.446-13.062 5.11a14.592 14.592 0 00-2.194-12.343c-2.288-3.214 12.648-3.034 12.648-3.034z"
                />
                <path
                    fill="#dd9569"
                    d="M256.645 119.308c-1.975-2.804-2.463-7.109-2.571-9.141l-10.42 6.718c0 .014.005.019.014.027.409.051 8.07 1.104 10.292 6.28 2.16-1.185 3.56-2.64 2.685-3.884z"
                />
                <path
                    fill="#efb185"
                    d="M236.248 93.56s-1.703 6.084-.658 11.047c1.11 5.344.425 6.523 1.041 8.886.256 1.008.505 2.549 1.63 3.4 1.839 1.42 5.341 1.631 9.804-.594 5.393-2.698 10.45-11.108 7.255-17.789-3.19-6.686-11.243-11.578-19.072-4.95z"
                />
                <path
                    fill="#e6a376"
                    d="M255.918 106.06c-2.966-6.004-9.403-12.886-9.397-13.287 0-.25-1.996-1.204-4.244-2.209a12.708 12.708 0 00-6.029 2.996 31.744 31.744 0 00-.752 3.88c1.518 1.35 4.44 2.752 4.99 3.98a16.297 16.297 0 01.61 9.597c-.67 2.103 3.279 4.642 2.717 6.505a.388.388 0 00.005.242 15.258 15.258 0 0012.1-11.703z"
                />
                <path
                    fill="#221101"
                    d="M234.315 91.356a7.25 7.25 0 004.942 6.94c3.116 1.113 3.389 5.906 3.344 6.805-.04.907-.457 5.015-.032 5.49.798.914 2.76-2.442 3.878-2.352 2.87.226 2.072 2.958-.162 5.984-2.379 3.206 4.87 3.6 7.888.829 1.612-1.468 2.163-2.305 3.948-7.133 2.592-7.033 1.863-15.049-6.494-18.433-8.35-3.375-12.206 3.252-17.312 1.87z"
                />
                <path
                    fill="#341c09"
                    d="M254.173 115.052c1.612-1.468 2.163-2.305 3.948-7.133 2.592-7.033 1.863-15.049-6.494-18.433-8.35-3.375-12.206 3.252-17.312 1.87a7.096 7.096 0 00.267 2.001c2.543.12 9.517.697 11.6 3.436 2.584 3.37 4.852 1.932 5.175 6.445.321 4.348 2.075 9.885-4.91 13.15 2.918 1.638 6.557-.255 7.726-1.336z"
                />
                <path
                    fill="#8525d9"
                    d="M244.255 122.085l-4.459 4.694s15.819 2.672 19.47-5.35c.507-1.13-.662-4.608-3.413-4.968 0 0 .17 6.165-11.598 5.624zM234.312 180.193c1.72-12.881-1.056-25.845-2.074-30.603-1.017-4.714-4.9-13.882 5.991-21.686 4.329 2.004 10.775 6.63 8.468 15.958-2.859 11.531-1.513 35.686-1.142 46.164-4.922 0-12.296-1.931-11.243-9.833z"
                />
                <path
                    fill="#efb185"
                    d="M208.275 106.206s.486-3.766-.684-5.027c-1.172-1.266-3.733-6.467-4.825-7.17-1.096-.707-.67 1.373-.338 2.75.332 1.378.13 4.058-.346 3.723-.472-.337-2.671 1.249-2.268 3.185.406 1.937 3.54 5.065 3.599 5.483.06.42 4.862-2.944 4.862-2.944z"
                />
                <path
                    fill="#b64fff"
                    d="M243.662 136.488s1.315-6.222-7.442-8.408a157.996 157.996 0 00-17.812-3.209l-10.005-18.206s-3.957-.335-5.385 1.973c0 0 4.715 19.813 10.948 24.656 0 0 28.612 17.397 29.696 3.194z"
                />
            </g>
        </svg>
    );
}

export default WebSvg;